import { useEffect, useState } from "react";

import { useSentimentTopicPromptsData } from "app/pages/digital-marketing/generative-ai/llm-tracker/reports/sentiment-report/hooks/useSentimentTopicPromptsData";
import { getBaseWidgetRequestParams } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/LLMTrackerUtils";
import type { ILLMReportWidget } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/types";
import { allTrackers } from "app/services/track/track";

import { DEFAULT_TAB, MAX_PROMPTS_PER_SENTIMENT } from "../consts";
import { SentimentTab } from "../types";

interface IUseTopicPromptsSidePanelParams extends Omit<ILLMReportWidget, "reportStatus"> {
    isOpen: boolean;
    topic: string;
}

export const useTopicPromptsSidePanel = ({
    isOpen,
    topic,
    campaign,
    campaignConfig,
    reportDuration,
}: IUseTopicPromptsSidePanelParams) => {
    const [selectedTab, setSelectedTab] = useState<SentimentTab>(DEFAULT_TAB);
    const sentimentTabs = Object.values(SentimentTab);

    const { data, isLoading, error } = useSentimentTopicPromptsData(
        {
            ...getBaseWidgetRequestParams(campaign, campaignConfig, reportDuration),
            maxPromptsPerSentiment: MAX_PROMPTS_PER_SENTIMENT,
            topic,
        },
        { enabled: isOpen },
    );

    const handleTabSelection = (tab: SentimentTab): void => {
        setSelectedTab(tab);
        allTrackers.dispatchTrackEvent("Filter", "click", "LLM Tracker/Sentiment side panel/sentiment filter", {
            filter: tab,
        });
    };

    //reset back to default tab when clicking on another topic
    useEffect(() => {
        setSelectedTab(DEFAULT_TAB);
    }, [data]);

    return {
        data,
        isLoading,
        hasError: !!error,
        selectedTab,
        sentimentTabs,
        handleTabSelection,
    };
};
